import { render, staticRenderFns } from "./index.vue?vue&type=template&id=bd4d9e0c&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=bd4d9e0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd4d9e0c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bd4d9e0c')) {
      api.createRecord('bd4d9e0c', component.options)
    } else {
      api.reload('bd4d9e0c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=bd4d9e0c&scoped=true&", function () {
      api.rerender('bd4d9e0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modals/info-modal/index.vue"
export default component.exports